import { IconButton, SvgIcon } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { spaces } from '../../../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../../../utils/getMuiIcon';

const StopButton = ({
  onStopResponse,
  disabled = false,
}: {
  onStopResponse: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('assistant');
  return (
    <IconButton
      data-testid='ai-assistant-stop-button'
      type='button'
      color='primary'
      sx={{ padding: spaces.xxs }}
      onClick={onStopResponse}
      disabled={disabled}
      aria-label={t('Stop generation')}
    >
      <SvgIcon
        sx={{ width: 24, height: 24 }}
        viewBox='0 0 35 35'
        component={getMuiIcon('stopCircle')}
        aria-hidden='true'
      /> 
    </IconButton>
  );
};

export default StopButton;
